import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/TextField.css'

const PreferredHand = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  
  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className='formFieldContainer'>
        <label className='formLabel'>
            {t('form.preferredHand')}
            <select className='textField-select'
            name="preferredHand"
            value={value}
            onChange={handleInputChange}>
            <option value="">{t('form.select')}</option>
            <option value={t('form.left')}>{t('form.left')}</option>
            <option value={t('form.right')}>{t('form.right')}</option>
            </select>
            {error && <span className="errorMessage">{error}</span>}
        </label>
    </div>
  );
};

export default PreferredHand;